import React, { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Environment } from 'src/Environment';
import { Onboarding, SelfService } from '../containers';
import { FullPageLoader, HelpFloatingActionButton } from 'src/components';
import BrokerSelfService from 'src/containers/self-service/broker-journey/broker-self-service';
import ToastMessageQueue from 'src/components/toast-message-queue/toast-message-queue';
import { QueryConfigProvider } from 'src/context/query-config-context';

import {
  merchantLoginRoute,
  onboardingDeclinedApplication,
  onboardingLegacyDeclinedApp,
  onboardingRoute,
  onboardingBrokerRoute,
  onboardingRoutePos,
} from 'src/routing/routes';
import { CacheContextProvider, HelpButton } from '../features/common';
import { QueryConfigContextProvider } from '../features/common/context/query-config-context';
import { DeclinedApplication as LegacyDeclinedApp } from 'src/containers/onboarding/create-account/declined-application/declined-application';
import { DeclinedApplication } from 'src/features/common/pages/declined-application/declined-application';
import TechnicalError from 'src/features/common/components/technical-error/technical-error';

const CommonApp = React.lazy(() => import('../features/common/app/common.app'));

export const staticRoutes = (
  <TechnicalError>
    <QueryConfigProvider>
      <CacheContextProvider cacheKey="onboarding">
        <QueryConfigContextProvider cacheKey="query-string">
          <Suspense fallback={<FullPageLoader />}>
            <Switch>
              {!Environment.current?.disabledFeatures?.oldPageRedirect &&
                window.location.search.startsWith('?orderNo=') && (
                  <Redirect
                    from="/merchant/index.html"
                    to={'/onboarding/create-account/confirm' + window.location.search}
                  />
                )}
              {!Environment.current?.disabledFeatures?.oldPageRedirect && (
                <Redirect from="/merchant/index.html" to={window.location.hash.substring(1)} />
              )}

              {!Environment.current.disabledFeatures.thirdParty && (
                <Route path={onboardingBrokerRoute} component={BrokerSelfService} />
              )}

              <Route path={onboardingLegacyDeclinedApp} component={LegacyDeclinedApp} />
              <Route path={onboardingDeclinedApplication} component={DeclinedApplication} />

              <Route
                path={onboardingRoutePos}
                component={() => <CommonApp basePath={onboardingRoutePos} />}
              />
              <Route path={onboardingRoute} component={Onboarding} />
              <Route path={merchantLoginRoute} component={SelfService} />
              {!Environment.current?.disabledFeatures?.oldPageRedirect && (
                <Redirect from="/" to="/merchant" />
              )}
            </Switch>
          </Suspense>
          <Switch>
            <Route
              path={onboardingBrokerRoute}
              component={() => (
                <div className="toast-help-container">
                  <ToastMessageQueue className="self-service-toast-message-queue" />
                  <HelpButton className="HelpButtonBottom" />
                </div>
              )}
            />
            <Route
              path={onboardingRoute}
              component={() => (
                <div className="toast-help-container">
                  <ToastMessageQueue />
                </div>
              )}
            />
            <Route
              path={merchantLoginRoute}
              component={() => (
                <div className="toast-help-container">
                  <ToastMessageQueue className="self-service-toast-message-queue" />
                  <HelpFloatingActionButton />
                </div>
              )}
            />
          </Switch>
        </QueryConfigContextProvider>
      </CacheContextProvider>
    </QueryConfigProvider>
  </TechnicalError>
);
